var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgVolume = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m7.606 5.62 2.692-1.616a.5.5 0 0 1 .757.429v7.134a.5.5 0 0 1-.757.429L7.606 10.38a1.5 1.5 0 0 0-.772-.213h-1.39a.5.5 0 0 1-.5-.5V6.333a.5.5 0 0 1 .5-.5h1.39a1.5 1.5 0 0 0 .772-.213Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgVolume);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/volume.ccd3e3032f4b9c82e86c265fcba1a48a.svg";